<template>
    <img
        :src="logo"
        width="64"
        height="20"
        alt="clearpay-logo"
    >
</template>

<script>
export default {
    computed: {
        logo () {
            return window.theme.assets.clearpay
        }
    }
}
</script>
